import {
    ADD_SPLIT_NODE,
    EDIT_SPLIT_BRANCH,
    EDIT_SPLIT_NODE,
    REMOVE_SPLIT_NODE,
} from 'domains/campaigns/state/actionTypes';
import { SplitActions } from 'domains/campaigns/types';
import { SegmentDefinition } from 'domains/segments/types';
import { Action } from 'models/types';

export type SplitBranch = {
    action: SplitActions | null;
    contentId: string | null;
};

export type SplitNodeEntry = {
    segmentDefinition: SegmentDefinition | null;
    isComplete: boolean;
    meets: SplitBranch;
    doesNotMeet: SplitBranch;
};

export type SplitNodesState = {
    [splitNodeId: string]: SplitNodeEntry;
};

const emptySplitBranch: SplitBranch = {
    action: null,
    contentId: null,
};

const emptyNode = (): SplitNodeEntry => ({
    segmentDefinition: null,
    isComplete: false,
    meets: { ...emptySplitBranch },
    doesNotMeet: { ...emptySplitBranch },
});

export const isSplitNodeComplete = (node: SplitNodeEntry): boolean =>
    !!node.segmentDefinition && node.meets.action !== null && node.doesNotMeet.action !== null;

const splitNodesReducer = (state: SplitNodesState = {}, action: Action): SplitNodesState => {
    switch (action.type) {
        case ADD_SPLIT_NODE: {
            const { splitNodeId } = action.payload;
            return { ...state, [splitNodeId]: emptyNode() };
        }
        case REMOVE_SPLIT_NODE: {
            const { splitNodeId } = action.payload;
            if (!state[splitNodeId]) return state;
            const next = { ...state };
            delete next[splitNodeId];
            return next;
        }
        case EDIT_SPLIT_NODE: {
            const { splitNodeId, field, value } = action.payload;
            if (!state[splitNodeId]) return state;
            const updated = { ...state[splitNodeId], [field]: value };
            return {
                ...state,
                [splitNodeId]: { ...updated, isComplete: isSplitNodeComplete(updated) },
            };
        }
        case EDIT_SPLIT_BRANCH: {
            const { splitNodeId, field, value } = action.payload;
            const branch = action.payload.branch as 'meets' | 'doesNotMeet';
            if (!state[splitNodeId]) return state;
            const updatedBranch = { ...state[splitNodeId][branch], [field]: value };
            const updatedNode = { ...state[splitNodeId], [branch]: updatedBranch };
            return {
                ...state,
                [splitNodeId]: { ...updatedNode, isComplete: isSplitNodeComplete(updatedNode) },
            };
        }
        default:
            return state;
    }
};

export default splitNodesReducer;
